( function( $ ) {
	// Used in main course page
	// Checks if the content of it is greater than 220 and if so, adds a toggle button
	const courseHeight = $( '.single-course__content' ).height();
	const maxContentHeight = 220;

	if ( courseHeight > maxContentHeight ) {
		// following variable comes from includes/classes/learndash/class-course-expand-content.php
		const expandButtonText = QalaTheme.learndash.course.expandable_text_string;
		$( '.single-course__content' ).addClass( 'expandable' );
		$( '.single-course__content' ).css( 'max-height', maxContentHeight );
		$( '.single-course__content' ).append( '<div class="expand-content">' + expandButtonText + '  →</div>' );

		$( '.expand-content' ).on( 'click', function() {
			$( '.single-course__content' ).removeClass( 'expandable' ).css( 'max-height', 'unset' );
			$( '.expand-content' ).remove();
		} );
	}
}( jQuery ) );
